/**
 * Layout Component
 *
 * Features:
 * - Handles academy authentication and redirects based on JWT validation.
 * - Integrates Pusher for real-time logout events for specific academies.
 * - Displays loading state until authentication and academy info are validated.
 * - Renders main header, banners, and children content.
 * - Uses Redux for academy info and Material-UI for UI components.
 */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import axios from 'axios';
import Pusher from 'pusher-js';

import Cookies from 'js-cookie';
const jwtCookie = Cookies.get(
  `${process.env.REACT_APP_COOKIE_CONSTANT}`
);

import MainHeader from '../MainHeader/MainHeader';
import HeaderBanner from 'components/UI/HeaderBanner/HeaderBanner';
import FooterBanner from 'components/UI/FooterBanner/FooterBanner';
import Loading from 'components/UI/Loading/Loading';
import classes from './Layout.module.css';

const Layout = props => {
  const url = window.location.pathname.split('/');
  const dataAcademy = useSelector(state => state.academyInfo);
  const [showPage, setShowPage] = useState(false);
  const [channel, setChannel] = useState('false');

  useEffect(() => {
    if (dataAcademy !== undefined) {
      if (
        dataAcademy.data.idAcademy === 1816 ||
        dataAcademy.data.idAcademy === 58 ||
        dataAcademy.data.idAcademy === 1153
      ) {
        if (jwtCookie) {
          axios
            .post('https://saml.mayahii.com/validate', {
              jwt: jwtCookie
            })
            .then(response => {
              if (!response.data.jwtStatus) {
                document.cookie =
                  'mayahiijwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.mayahii.com;';
                window.location.href = `https://saml.mayahii.com/connect?connection=TEC&returnUrl=${encodeURIComponent(
                  `${process.env.REACT_APP_API_PATH_MAYAHII}/${dataAcademy.data.shortName}`
                )}`;
              } else {
                setChannel(response.data.channel);
                setShowPage(true);
              }
            });
        } else {
          window.location.href = `https://saml.mayahii.com/connect?connection=TEC&returnUrl=${encodeURIComponent(
            `${process.env.REACT_APP_API_PATH_MAYAHII}/${dataAcademy.data.shortName}`
          )}`;
        }
      } else {
        setShowPage(true);
      }
    }
  }, [dataAcademy.data]);

  useEffect(() => {
    if (
      (dataAcademy.data.idAcademy === 1816 ||
        dataAcademy.data.idAcademy === 58 ||
        dataAcademy.data.idAcademy === 1153) &&
      channel
    ) {
      let pusher = new Pusher('8077d5a80229a942c1b8', {
        cluster: 'mt1'
      });
      let channel = pusher.subscribe(this.state.channel);
      channel.bind('logout', function (data) {
        console.log(JSON.stringify(data));
        document.cookie =
          'mayahiijwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.mayahii.com;';
        window.location.href = `https://saml.mayahii.com/connect?connection=TEC&returnUrl=${encodeURIComponent(
          `${process.env.REACT_APP_API_PATH_MAYAHII}/${dataAcademy.data.shortName}`
        )}`;
      });
    }
  }, [channel]);

  return (
    <>
      {!showPage ? (
        <Loading /> // No props passed to Loading
      ) : (
        <>
          {url[2] !== 'lp' && (
            <MainHeader /> // No props passed to MainHeader
          )}
          {/* No props passed to HeaderBanner */}
          <HeaderBanner />
          <main className={classes.mainContainer}>
            {/* Props passed to children:
                - children: React nodes to be rendered inside main
            */}
            {props.children}
          </main>
          {/* No props passed to FooterBanner */}
          <FooterBanner />
        </>
      )}
    </>
  );
};

Layout.propTypes = {
  /**
   * React children nodes to be rendered inside the layout
   */
  children: PropTypes.node
};

Layout.defaultProps = {
  children: null
};

export default Layout;
